/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceiveAddressVo
 */
export interface ReceiveAddressVo {
    /**
     * 收货地址ID
     * @type {number}
     * @memberof ReceiveAddressVo
     */
    id?: number;
    /**
     * 用户id，对应user表的id
     * @type {number}
     * @memberof ReceiveAddressVo
     */
    userId?: number;
    /**
     * 国家id
     * @type {number}
     * @memberof ReceiveAddressVo
     */
    nationId?: number;
    /**
     * 收件人姓名（韩文）
     * @type {string}
     * @memberof ReceiveAddressVo
     */
    nameKr?: string;
    /**
     * 收件人姓名（英文）
     * @type {string}
     * @memberof ReceiveAddressVo
     */
    nameEn?: string;
    /**
     * 收件人邮编
     * @type {string}
     * @memberof ReceiveAddressVo
     */
    zip?: string;
    /**
     * 收件人地址
     * @type {string}
     * @memberof ReceiveAddressVo
     */
    address?: string;
    /**
     * 收件人详细地址
     * @type {string}
     * @memberof ReceiveAddressVo
     */
    addressDetail?: string;
    /**
     * 收件人地址（英文）
     * @type {string}
     * @memberof ReceiveAddressVo
     */
    addressEn?: string;
    /**
     * 收件人详细地址（英文）
     * @type {string}
     * @memberof ReceiveAddressVo
     */
    addressDetailEn?: string;
    /**
     * 收件人电话
     * @type {string}
     * @memberof ReceiveAddressVo
     */
    mobileNo?: string;
    /**
     * 证件类型
     * @type {number}
     * @memberof ReceiveAddressVo
     */
    ctmsType?: number;
    /**
     * 证件号码
     * @type {string}
     * @memberof ReceiveAddressVo
     */
    ctmsNo?: string;
    /**
     * 是否默认 0 不是， 1 是
     * @type {number}
     * @memberof ReceiveAddressVo
     */
    defaultChoice?: number;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof ReceiveAddressVo
     */
    enable?: number;
}

/**
 * Check if a given object implements the ReceiveAddressVo interface.
 */
export function instanceOfReceiveAddressVo(value: object): value is ReceiveAddressVo {
    return true;
}

export function ReceiveAddressVoFromJSON(json: any): ReceiveAddressVo {
    return ReceiveAddressVoFromJSONTyped(json, false);
}

export function ReceiveAddressVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiveAddressVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'nationId': json['nationId'] == null ? undefined : json['nationId'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'address': json['address'] == null ? undefined : json['address'],
        'addressDetail': json['addressDetail'] == null ? undefined : json['addressDetail'],
        'addressEn': json['addressEn'] == null ? undefined : json['addressEn'],
        'addressDetailEn': json['addressDetailEn'] == null ? undefined : json['addressDetailEn'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'ctmsType': json['ctmsType'] == null ? undefined : json['ctmsType'],
        'ctmsNo': json['ctmsNo'] == null ? undefined : json['ctmsNo'],
        'defaultChoice': json['defaultChoice'] == null ? undefined : json['defaultChoice'],
        'enable': json['enable'] == null ? undefined : json['enable'],
    };
}

export function ReceiveAddressVoToJSON(json: any): ReceiveAddressVo {
    return ReceiveAddressVoToJSONTyped(json, false);
}

export function ReceiveAddressVoToJSONTyped(value?: ReceiveAddressVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'nationId': value['nationId'],
        'nameKr': value['nameKr'],
        'nameEn': value['nameEn'],
        'zip': value['zip'],
        'address': value['address'],
        'addressDetail': value['addressDetail'],
        'addressEn': value['addressEn'],
        'addressDetailEn': value['addressDetailEn'],
        'mobileNo': value['mobileNo'],
        'ctmsType': value['ctmsType'],
        'ctmsNo': value['ctmsNo'],
        'defaultChoice': value['defaultChoice'],
        'enable': value['enable'],
    };
}

